import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { format } from "date-fns";

import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import DatePickerInput from "../../components/Input/DatepickerInput";
import Select from "../../components/Input/SelectInput";
import axios from "../../utils/helpers/axios";
import { ToggleSidebarContext } from "../../components/Layout/Layout";

import ImportIcon from "../../assets/svg/importIconWhite";

export default function Reports() {
  const { setToggleSidebar } = useContext(ToggleSidebarContext);

  const [communities, setCommunities] = useState([]);
  const [reportData, setReportData] = useState({
    communityId: "",
    startDate: "",
    endDate: "",
    reportType: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const availableReports = [
    { id: "attorneyViolations", title: "Attroney Violations" },
    { id: "allopenViolations", title: "Violations Currently Open" },
    { id: "openViolations", title: "Violations Open Within Date Range" },
    { id: "closedViolations", title: "Violations Closed Within Date Range" },
    { id: "letterViolations", title: "Violation Activity within Date Range" },
  ];

  const getCommunities = async () => {
    try {
      const { data } = await axios.get(
        "/api/community?sortFields=updatedAt&sortOrders=-1"
      );

      if (data.success) {
        setCommunities(data.communities);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const downloadCSV = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(
        `/api/company/generateReport`,
        reportData
      );

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "downloadedCSV.csv";
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message || "Error downloading the CSV file"
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCommunities();
  }, []);

  return (
    <div className="w-full">
      <Header title="Reports" buttonText="Northdale HOA .Inc" />
      <div
        onClick={() => setToggleSidebar(false)}
        className="w-full h-[92%] flex flex-col px-8 pt-4 gap-4"
      >
        <div className="flex flex-col grow gap-[1rem] max-h-[86%]">
          <div className="flex justify-between gap-[1rem] w-full">
            <Select
              label="Report"
              labelClass="text-primary-teal"
              type="select"
              placeholder="Select Report"
              inputFieldClass="px-4"
              outerClass="w-full"
              extraClass="border-gray border-[1px] rounded-full"
              id="id"
              fieldName="title"
              info={"info"}
              handleChange={(id, data) =>
                setReportData((prev) => ({ ...prev, reportType: data?.id }))
              }
              value={
                availableReports.find(
                  (type) => type?.id === reportData?.reportType
                )?.title
              }
              dropdownData={availableReports || []}
              required={true}
            />
            <Select
              label="Community"
              labelClass="text-primary-teal"
              type="select"
              placeholder="Select Community"
              inputFieldClass="px-4"
              outerClass="w-full"
              extraClass="border-gray border-[1px] rounded-full"
              id="community"
              fieldName="letterName"
              info={"info"}
              handleChange={(id, data) => {
                setReportData((prev) => ({ ...prev, communityId: data?._id }));
              }}
              value={
                communities?.find(
                  (community) => community?._id === reportData?.communityId
                )?.letterName
              }
              dropdownData={communities || []}
              required={true}
            />
          </div>
          <div className="flex justify-between gap-[1rem] w-full">
            <DatePickerInput
              label="Start Date"
              labelClass="text-primary-teal"
              placeholder="Start Date"
              type="text"
              inputFieldClass="px-4"
              id="subscriptionStartDate"
              outerClass="w-full"
              extraClass="border-gray border-[1px] rounded-full"
              info={"info"}
              required={true}
              handleChange={(id, formatedDate, date) => {
                setReportData((prev) => ({
                  ...prev,
                  startDate: date?.toISOString(),
                }));
              }}
              value={
                reportData?.startDate
                  ? format(new Date(reportData.startDate), "MMMM d, yyyy")
                  : ""
              }
            />
            <DatePickerInput
              label="End Date"
              labelClass="text-primary-teal"
              placeholder="End Date"
              type="text"
              inputFieldClass="px-4"
              id="subscriptionEndDate"
              outerClass="w-full"
              extraClass="border-gray border-[1px] rounded-full"
              info={"info"}
              required={true}
              handleChange={(id, formatedDate, date) => {
                setReportData((prev) => ({
                  ...prev,
                  endDate: date?.toISOString(),
                }));
              }}
              value={
                reportData?.endDate
                  ? format(new Date(reportData.endDate), "MMMM d, yyyy")
                  : ""
              }
            />
            {/* <Select
              label="Level"
              labelClass="text-primary-teal"
              type="select"
              placeholder="Select Level"
              inputFieldClass="px-4"
              outerClass="w-full"
              extraClass="border-gray border-[1px] rounded-full"
              id="subscriptionType"
              fieldName="subscriptionType"
              info={"info"}
              handleChange={() => {}}
              value={""}
              dropdownData={[]}
            /> */}
          </div>
          {/* <div className="flex flex-col gap-[1rem]">
            <div className="w-1/3 flex justify-between border-b-[1px] border-gray">
              <span className="text-primary-teal font-semibold">
                Initial violation Date Range
              </span>
              <SwitchInputv2 isChecked={true} onChange={(id, value) => {}} />
            </div>
            <div className="flex justify-between gap-[1rem] w-[66%]">
              <DatePickerInput
                label="Start Date"
                labelClass="text-primary-teal"
                placeholder="Start Date"
                type="text"
                inputFieldClass="px-4"
                id="subscriptionStartDate"
                outerClass="w-full"
                extraClass="border-gray border-[1px] rounded-full"
                info={"info"}
              />
              <DatePickerInput
                label="End Date"
                labelClass="text-primary-teal"
                placeholder="End Date"
                type="text"
                inputFieldClass="px-4"
                id="subscriptionEndDate"
                outerClass="w-full"
                extraClass="border-gray border-[1px] rounded-full"
                info={"info"}
              />
            </div>
          </div>
          <div className="flex flex-col gap-[1rem]">
            <div className="w-1/3 flex justify-between border-b-[1px] border-gray">
              <span className="text-primary-teal font-semibold">
                Closed violation Date Range
              </span>
              <SwitchInputv2 isChecked={true} onChange={(id, value) => {}} />
            </div>
            <div className="flex justify-between gap-[1rem] w-[66%]">
              <DatePickerInput
                label="Start Date"
                labelClass="text-primary-teal"
                placeholder="Start Date"
                type="text"
                inputFieldClass="px-4"
                id="subscriptionStartDate"
                outerClass="w-full"
                extraClass="border-gray border-[1px] rounded-full"
                info={"info"}
              />
              <DatePickerInput
                label="End Date"
                labelClass="text-primary-teal"
                placeholder="End Date"
                type="text"
                inputFieldClass="px-4"
                id="subscriptionEndDate"
                outerClass="w-full"
                extraClass="border-gray border-[1px] rounded-full"
                info={"info"}
              />
            </div>
          </div> */}
        </div>
        <div className="flex justify-end gap-4">
          {/* <Button
            type="submit"
            Icon={ImportIcon}
            iconClass="w-[15px] h-[15px]"
            innerText="Download PDF"
            extraClass="shadow-button border-[0.5px] border-primary-teal bg-primary-teal px-4 text-sm py-2 rounded-full text-primary-white"
          /> */}
          <Button
            type="submit"
            Icon={ImportIcon}
            iconClass="h-[1rem] "
            innerText="Download CSV"
            extraClass="shadow-button border-[0.5px] border-primary-teal bg-primary-teal px-4 text-sm py-2 rounded-full text-primary-white"
            onClick={downloadCSV}
            spinnerLight={true}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
